<!--
 * @Autor: GeekMzy
 * @Date: 2022-05-16 14:54:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-24 11:20:07
 * @FilePath: \htwlgs-drainage-webv2-shiju\src\components\common\ListTable.vue
 * @Author: desktop-1llkr2o
-->
<template>
  <div class="list_container">
    <div class="list_title">
      <slot name="list_title"></slot>
    </div>
    <slot name="list_filter"></slot>
    <div class="list_content" :class="horizontal ? 'horizontal' : ''">
      <div :style="{ width: horizontal ? `${props.tableColumns.length * 120}px` : '100%' }">
        <div class="table_columns">
          <div
            v-for="column in props.tableColumns"
            :key="column.key"
            class="columns_item"
            :style="{ width: column.width || '100px' }"
          >
            {{ column.label }}
          </div>
        </div>
        <div
          class="table_list"
          :style="{
            maxHeight: props.maxHeight,
          }"
        >
          <div
            :class="props.scroll && props.tableData.length > 20 ? 'scroll' : ''"
            :style="{ 'animation-duration': props.tableData.length * 2 + 's' }"
            v-if="props.tableData.length>0"
          >
            <div ref="listContent">
              <div
                v-for="row in props.tableData"
                :key="row.key"
                class="list_item"
                @click="onTableItemClick(row)"
              >
                <div
                  v-for="item in props.tableColumns"
                  :key="item.key"
                  class="row_item"
                  :class="{
                    text_just: item.isTextJust || false,
                  }"
                  :style="{ width: item.width || '100px' }"
                >
                  <n-tooltip trigger="hover">
                    <template #trigger>
                      <div :style="{ color: getstyle(row, item) }">
                        {{ row[item.key] ? row[item.key] : '--' }}
                      </div>
                    </template>
                    <div
                      class="nowrap"
                      :style="{
                        maxWidth: item.width || '100px',
                      }"
                    >
                      {{ row[item.key] ? row[item.key] : '--' }}
                    </div>
                  </n-tooltip>
                </div>
              </div>
            </div>
            <div v-if="props.scroll && props.tableData.length > 20" ref="listContent2">
              <div
                v-for="row in props.tableData"
                :key="row.key"
                class="list_item"
                @click="onTableItemClick(row)"
              >
                <div
                  v-for="item in props.tableColumns"
                  :key="item.key"
                  class="row_item"
                  :class="{
                    text_just: item.isTextJust || false,
                  }"
                  :style="{ width: item.width || '100px' }"
                >
                  <n-tooltip placement="top-start" trigger="hover">
                    <template #trigger>
                      <div :style="{ color: getstyle(row, item) }">
                        {{ row[item.key] ? row[item.key] : '--' }}
                      </div>
                    </template>
                    <div
                      class="nowrap"
                      :style="{
                        maxWidth: item.width || '100px',
                      }"
                    >
                      {{ row[item.key] ? row[item.key] : '--' }}
                    </div>
                  </n-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div v-else style="display: flex;align-items: center;justify-content: center;padding: 48px 0;">
            <div class="n-empty" style="--n-icon-size: 40px; --n-font-size: 14px; --n-bezier: cubic-bezier(.4, 0, .2, 1); --n-text-color: rgba(255, 255, 255, 0.38); --n-icon-color: rgba(255, 255, 255, 0.38); --n-extra-text-color: rgba(255, 255, 255, 0.82);"><div class="n-empty__icon"><i class="n-base-icon"><svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 7.5C26 11.0899 23.0899 14 19.5 14C15.9101 14 13 11.0899 13 7.5C13 3.91015 15.9101 1 19.5 1C23.0899 1 26 3.91015 26 7.5ZM16.8536 4.14645C16.6583 3.95118 16.3417 3.95118 16.1464 4.14645C15.9512 4.34171 15.9512 4.65829 16.1464 4.85355L18.7929 7.5L16.1464 10.1464C15.9512 10.3417 15.9512 10.6583 16.1464 10.8536C16.3417 11.0488 16.6583 11.0488 16.8536 10.8536L19.5 8.20711L22.1464 10.8536C22.3417 11.0488 22.6583 11.0488 22.8536 10.8536C23.0488 10.6583 23.0488 10.3417 22.8536 10.1464L20.2071 7.5L22.8536 4.85355C23.0488 4.65829 23.0488 4.34171 22.8536 4.14645C22.6583 3.95118 22.3417 3.95118 22.1464 4.14645L19.5 6.79289L16.8536 4.14645Z" fill="currentColor"></path><path d="M25 22.75V12.5991C24.5572 13.0765 24.053 13.4961 23.5 13.8454V16H17.5L17.3982 16.0068C17.0322 16.0565 16.75 16.3703 16.75 16.75C16.75 18.2688 15.5188 19.5 14 19.5C12.4812 19.5 11.25 18.2688 11.25 16.75L11.2432 16.6482C11.1935 16.2822 10.8797 16 10.5 16H4.5V7.25C4.5 6.2835 5.2835 5.5 6.25 5.5H12.2696C12.4146 4.97463 12.6153 4.47237 12.865 4H6.25C4.45507 4 3 5.45507 3 7.25V22.75C3 24.5449 4.45507 26 6.25 26H21.75C23.5449 26 25 24.5449 25 22.75ZM4.5 22.75V17.5H9.81597L9.85751 17.7041C10.2905 19.5919 11.9808 21 14 21L14.215 20.9947C16.2095 20.8953 17.842 19.4209 18.184 17.5H23.5V22.75C23.5 23.7165 22.7165 24.5 21.75 24.5H6.25C5.2835 24.5 4.5 23.7165 4.5 22.75Z" fill="currentColor"></path></svg></i></div><div class="n-empty__description">无数据</div><!----></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
const emit = defineEmits(['tableItemClick'])
function getstyle(row, item) {
  if (row[item.iscb]) return '#FF3030'
  if (
    row[item.key] == 'Ⅰ' ||
    row[item.key] == 'Ⅰ类' ||
    row[item.key] == 'Ⅱ类' ||
    row[item.key] == 'Ⅱ'
  ) {
    return '#41A5E6'
  } else if (row[item.key] == 'Ⅲ' || row[item.key] == 'Ⅲ类' || row[item.key] == '达标') {
    return '#00FF4E'
  } else if (row[item.key] == 'Ⅳ' || row[item.key] == 'Ⅳ类') {
    return '#FFD225'
  } else if (row[item.key] == 'Ⅴ' || row[item.key] == 'Ⅴ类') {
    return '#DD9090'
  } else if (row[item.key] == '劣Ⅴ' || row[item.key] == '劣Ⅴ类' || row[item.key] == '超标') {
    return '#FF3030'
  }
}
const props = defineProps({
  horizontal: {
    type: Boolean,
    default: false,
  },
  scroll: {
    type: Boolean,
    default: false,
  },
  tableColumns: {
    type: Array,
    default: () => [],
  },
  tableData: {
    type: Array,
    default: () => [],
  },
  maxHeight: {
    type: String,
    default: '',
  },
})
// 列表点击事件
function onTableItemClick(row) {
  emit('tableItemClick', row)
}

const listContent = ref(null)
const listContent2 = ref(null)
onMounted(() => {
  // if (props.scroll) {
  //   listContent2.value.innerHtml = listContent.value.innerHtml
  // }
})
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 5px;
  display: block;
  height: 4px !important;
  background-color: 0088bf;
}
::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 2px;
}

@keyframes scroll {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(0, -40%, 0);
  }
}
.list_container {
  overflow-x: auto;
  .list_content {
    // max-width: 630px;
    overflow: hidden;
    &.horizontal {
      overflow-x: auto;
    }
    .table_columns {
      height: 45px;
      display: flex;
      align-items: center;
      background: linear-gradient(
        180deg,
        rgba(23, 79, 165, 0.6) 0%,
        rgba(135, 178, 231, 0.6) 306.67%
      );
      .columns_item {
        flex: 1;
        cursor: pointer;
        font-weight: 400;
        padding: 0 8px;
        font-size: 14px;
        line-height: 18px;
        color: #80e0ff;
        text-align: center;
      }
    }
    .table_list {
      overflow: hidden;
      overflow-y: scroll;
      .scroll {
        animation-name: scroll;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-direction: normal;
        &:hover {
          animation-play-state: paused;
        }
      }
      .list_item {
        height: 45px;
        display: flex;
        align-items: center;
        .item {
          display: flex;
          align-items: center;
        }
        .row_item {
          flex: 1;
          cursor: pointer;
          padding: 0 8px;
          font-weight: 400;
          font-size: 14px;
          line-height: 18px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .n-empty {
        .n-empty__icon {
          width: 40px;
          height: 40px;
          font-size: 40px;
          line-height: 40px;
          color: rgba(255, 255, 255, 0.38);
        }
        .n-empty__description {
          color: rgba(255, 255, 255, 0.38)
        }
      }
    }
  }
}
.list_title {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 21px;
  text-align: start;
}
.nowrap {
  white-space: normal;
}
.text_just {
  text-align-last: justify;
  text-align: justify;
}
</style>
